import { usePatientSearchBar } from '../hooks';
import {
  Autocomplete,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';
import { PatientSearchBarNoOptionsPlaceholder } from './PatientSearchBarNoOptionsPlaceholder.tsx';
import { t } from 'i18next';

export const PatientSearchBar = () => {
  const {
    searchQuery,
    value,
    handleSearchChange,
    handleValueChange,
    onFocus,
    onBlur,
    placeholder,
    patientOptions,
    isLoading,
    handleNavigate,
    inputRef,
    onClear,
  } = usePatientSearchBar();

  const noOptionsText =
    searchQuery && searchQuery.length > 2 ? (
      <PatientSearchBarNoOptionsPlaceholder />
    ) : (
      t('common.autocompletePlaceholder.enterThreeLetter')
    );

  return (
    <Autocomplete
      loading={isLoading}
      options={patientOptions}
      filterOptions={x => x}
      getOptionLabel={(option: { id: string; name: string }) =>
        option.name || ''
      }
      isOptionEqualToValue={(option, value) => option.id === value.id}
      value={value}
      inputValue={searchQuery}
      onInputChange={(event, newInputValue) => {
        if (event) {
          handleSearchChange(newInputValue);
        }
      }}
      onChange={(event, newValue) => {
        handleValueChange(newValue);
      }}
      renderOption={(liProps, option) => (
        <li {...liProps} key={option.id} onClick={() => handleNavigate(option)}>
          <Typography
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
          >
            {option.name}
          </Typography>
        </li>
      )}
      noOptionsText={noOptionsText}
      onFocus={onFocus}
      onBlur={onBlur}
      fullWidth
      renderInput={params => (
        <TextField
          {...params}
          inputRef={inputRef}
          placeholder={placeholder}
          fullWidth
          sx={{
            '& .MuiInputBase-input::placeholder': {
              color: 'text.secondary',
              opacity: 1,
            },
          }}
          onKeyDown={e => {
            if (e.code === 'Enter' && patientOptions.length > 0) {
              handleNavigate(patientOptions[0]);
            }
          }}
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              startAdornment: (
                <>
                  <InputAdornment position='start'>
                    <Search />
                  </InputAdornment>
                </>
              ),
              endAdornment: (
                <>
                  <InputAdornment position='end'>
                    {searchQuery && (
                      <IconButton onClick={onClear}>
                        <Clear />
                      </IconButton>
                    )}
                  </InputAdornment>
                </>
              ),
            },
          }}
        />
      )}
      autoComplete
      // size='small'
    />
  );
};
